import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const InvoiceIcon = (props: WrappingIconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 18V2H12V4C12 4.52725 12.1801 5.04433 12.5679 5.43211C12.9557 5.81989 13.4728 6 14 6H16V18H2ZM16 4V2H14V4H16ZM2 0C1.47275 0 0.955673 0.180114 0.567893 0.567893C0.180114 0.955673 0 1.47275 0 2V18C0 18.5272 0.180114 19.0443 0.567893 19.4321C0.955673 19.8199 1.47275 20 2 20H16C16.5272 20 17.0443 19.8199 17.4321 19.4321C17.8199 19.0443 18 18.5272 18 18V2C18 1.47275 17.8199 0.955673 17.4321 0.567893C17.0443 0.180114 16.5272 0 16 0H2ZM4 11C4 10.4477 4.44772 10 5 10H13C13.5523 10 14 10.4477 14 11C14 11.5523 13.5523 12 13 12H5C4.44772 12 4 11.5523 4 11ZM5 14C4.44772 14 4 14.4477 4 15C4 15.5523 4.44772 16 5 16H13C13.5523 16 14 15.5523 14 15C14 14.4477 13.5523 14 13 14H5Z"
      fill="#3D4B52"
    />
  </Icon>
);
